import { z } from 'zod';

/**
 * Use this to convert string enum values from the front end to numerical equivalents for back end services
 * @param enumOptions Array of enum options used to generate Zod enum
 * @returns Zod Schema that converts an enum's string value to its numerical equivalent for use with backend calls
 */
export function createRequestEnumPreprocessor(enumOptions: readonly string[]) {
  return z.preprocess((value) => {
    if (typeof value === 'string') {
      const stringIndex = enumOptions.indexOf(value);
      return stringIndex !== -1 ? stringIndex : value;
    }
    return value;
  }, z.number().min(0));
}
